import { render } from "./Focuspoints.vue?vue&type=template&id=2eabc6d5&scoped=true"
import script from "./Focuspoints.vue?vue&type=script&lang=js"
export * from "./Focuspoints.vue?vue&type=script&lang=js"

import "./Focuspoints.vue?vue&type=style&index=0&id=2eabc6d5&lang=scss&scoped=true"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eabc6d5"]])

export default __exports__